import {
    getChannelDisplayName,
    getChannelIndex,
    getEffectiveConnectors,
} from '@/helpers/channels/channelTableDisplay'
import { CHANNEL_TYPES, PROVIDER_TYPES } from '@root/src/vars/general'

const CHANNEL_DESCRIPTIONS = {
    wa: 'Личные сообщения клиентам',
    tg: 'Боты и каналы',
    max: 'Мессенджер без блокировок',
    maxb: 'Бизнес-аккаунт MAX',
    sms: 'SMS-сообщения клиентам',
}

export function isCascadeChannelConnector(connector) {
    return Object.values(CHANNEL_TYPES).includes(connector?.connectorType)
}

function getChannelKind(connector) {
    const provider = connector?.providerType || connector?.connectorType || ''

    if ([PROVIDER_TYPES.whatsappBasis, PROVIDER_TYPES.whatsappApi, PROVIDER_TYPES.whatsapp, PROVIDER_TYPES.whatsappDh].includes(provider)) {
        return 'wa'
    }
    if ([PROVIDER_TYPES.telegramApi, PROVIDER_TYPES.telegramDh].includes(provider)) {
        return 'tg'
    }
    if (provider === PROVIDER_TYPES.maxBusiness) {
        return 'maxb'
    }
    if (provider === PROVIDER_TYPES.maxBasis) {
        return 'max'
    }
    if ([PROVIDER_TYPES.smsGate, CHANNEL_TYPES.smsChannel].includes(provider)) {
        return 'sms'
    }

    return null
}

function getCommBgByKind(kind) {
    if (kind === 'wa') return '#29a71a'
    if (kind === 'tg') return '#23a8e9'
    if (kind === 'maxb') return '#6A3FC0'
    if (kind === 'sms') return '#43A047'
    return '#7B57D4'
}

function getCommMdiByKind(kind) {
    if (kind === 'wa') return 'mdi-whatsapp'
    if (kind === 'tg') return 'mdi-telegram'
    if (kind === 'maxb') return 'mdi-alpha-m-box'
    if (kind === 'sms') return 'mdi-message-text-outline'
    return 'mdi-alpha-m-box'
}

function getAvatarTypeByKind(kind) {
    if (kind === 'wa') return CHANNEL_TYPES.whatsappChannel
    if (kind === 'tg') return CHANNEL_TYPES.telegramChannel
    if (kind === 'maxb') return CHANNEL_TYPES.maxBusiness
    if (kind === 'sms') return CHANNEL_TYPES.smsChannel
    return CHANNEL_TYPES.maxChannel
}

export function buildCascadeChannelItems({ connectors, cascade, connectorsAvatars, slots }) {
    const slotConnectorIds = new Set(
        (slots || [])
            .filter(slot => slot?.channelConnectorId)
            .map(slot => String(slot.channelConnectorId)),
    )

    const isIncludedChannelConnector = connector => {
        if (!isCascadeChannelConnector(connector)) {
            return false
        }
        const connectorId = String(connector.connectorId || connector.id)
        if (connector?.isActive !== false) {
            return true
        }
        return slotConnectorIds.has(connectorId)
    }

    const channelConnectors = (connectors || []).filter(isIncludedChannelConnector)
    const effectiveConnectors = getEffectiveConnectors(connectors || [])
    const avatars = connectorsAvatars || []

    const priorityByConnectorId = {}
    ;(cascade?.channels || []).forEach(channel => {
        const connector = channelConnectors.find(item => item.channelId === channel.channelId)
        if (!connector) {
            return
        }
        const connectorId = String(connector.connectorId || connector.id)
        priorityByConnectorId[connectorId] = {
            priority: channel.priority,
            channelId: channel.channelId,
            cascadeChannelId: channel.id,
        }
    })

    const items = channelConnectors
        .filter(connector => {
            const connectorId = String(connector.connectorId || connector.id)
            const inCascade = !!priorityByConnectorId[connectorId]
            const inSlot = slotConnectorIds.has(connectorId)
            return inCascade || (inSlot && connector.channelId)
        })
        .map(connector => {
            const connectorId = String(connector.connectorId || connector.id)
            const priorityEntry = priorityByConnectorId[connectorId]
            const cascadeEnabled = !!priorityEntry?.channelId

            const kind = getChannelKind(connector)
            const providerType = connector.providerType || connector.connectorType
            const channelIndex = getChannelIndex(providerType, connector, effectiveConnectors)
            const avatarType = getAvatarTypeByKind(kind)
            const avatar = avatars.find(item => item.type === avatarType) || {}

            return {
                connectorId,
                channelId: connector.channelId || priorityEntry?.channelId || null,
                cascadeChannelId: priorityEntry?.cascadeChannelId || null,
                priority: priorityEntry?.priority ?? null,
                cascadeEnabled,
                providerType,
                displayName: getChannelDisplayName(providerType, channelIndex),
                description: CHANNEL_DESCRIPTIONS[kind] || connector.name || '',
                bg: getCommBgByKind(kind),
                mdiIcon: getCommMdiByKind(kind),
                image: avatar.image || null,
                symbol: avatar.symbol || null,
            }
        })
        .filter(item => item.channelId)

    const enabledItems = items
        .filter(item => item.cascadeEnabled)
        .sort((a, b) => a.priority - b.priority)
    const disabledItems = items.filter(item => !item.cascadeEnabled)

    return [...enabledItems, ...disabledItems]
}
